import * as THREE from "three";

const canvas = document.querySelector("[data-hero-canvas]");
const heroSection = document.querySelector("[data-hero]");
const fallback = document.querySelector(".hero__fallback");

if (!canvas || !heroSection) {
  // nothing to do
} else {
  let renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: false });
  } catch (e) {
    renderer = null;
  }

  if (!renderer) {
    if (fallback) fallback.style.opacity = "1";
  } else {
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    const scene = new THREE.Scene();
    const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 10);
    camera.position.z = 1;

    const loader = new THREE.TextureLoader();
    const bgImageSrc = canvas.dataset.bgImage || "assets/product-01-front.png";
    const texture = loader.load(
      bgImageSrc,
      () => {
        if (window.gsap) {
          window.gsap.to(material.uniforms.uAlpha, { value: 1, duration: 1.8, ease: "power2.out" });
        } else {
          material.uniforms.uAlpha.value = 1;
        }
      },
      undefined,
      () => {
        if (fallback) fallback.style.opacity = "1";
      }
    );
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;

    const material = new THREE.ShaderMaterial({
      uniforms: {
        uTexture: { value: texture },
        uTime: { value: 0 },
        uMouse: { value: new THREE.Vector2(0.5, 0.5) },
        uMouseEased: { value: new THREE.Vector2(0.5, 0.5) },
        uResolution: { value: new THREE.Vector2(1, 1) },
        uImageAspect: { value: 1556 / 2000 },
        uAlpha: { value: 0 },
      },
      vertexShader: `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = vec4(position, 1.0);
        }
      `,
      fragmentShader: `
        precision highp float;
        uniform sampler2D uTexture;
        uniform float uTime;
        uniform vec2 uMouseEased;
        uniform vec2 uResolution;
        uniform float uImageAspect;
        uniform float uAlpha;
        varying vec2 vUv;

        void main() {
          vec2 uv = vUv;

          float screenAspect = uResolution.x / uResolution.y;
          vec2 scale = vec2(1.0);
          if (screenAspect > uImageAspect) {
            scale.y = uImageAspect / screenAspect;
          } else {
            scale.x = screenAspect / uImageAspect;
          }
          vec2 fitUv = (uv - 0.5) * scale + 0.5;

          vec2 parallax = (uMouseEased - 0.5) * 0.025;
          fitUv += parallax;

          float t = uTime * 0.05;
          fitUv.x += sin(fitUv.y * 6.0 + t) * 0.0035;
          fitUv.y += cos(fitUv.x * 6.0 + t) * 0.0035;

          vec2 zoomed = (fitUv - 0.5) * 0.94 + 0.5;

          vec3 color = texture2D(uTexture, zoomed).rgb;

          float vig = smoothstep(0.95, 0.3, length(uv - 0.5));
          color *= mix(0.55, 1.0, vig);

          gl_FragColor = vec4(color, uAlpha);
        }
      `,
      transparent: true,
    });

    const geometry = new THREE.PlaneGeometry(2, 2);
    const mesh = new THREE.Mesh(geometry, material);
    scene.add(mesh);

    const mouse = { x: 0.5, y: 0.5 };
    const mouseEased = { x: 0.5, y: 0.5 };

    heroSection.addEventListener("mousemove", (e) => {
      const rect = heroSection.getBoundingClientRect();
      mouse.x = (e.clientX - rect.left) / rect.width;
      mouse.y = (e.clientY - rect.top) / rect.height;
    });

    function resize() {
      const w = heroSection.clientWidth;
      const h = heroSection.clientHeight;
      renderer.setSize(w, h, false);
      material.uniforms.uResolution.value.set(w, h);
    }
    resize();
    window.addEventListener("resize", resize);

    let visible = true;
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => { visible = entries[0].isIntersecting; },
        { threshold: 0 }
      );
      io.observe(heroSection);
    }

    const clock = new THREE.Clock();
    function tick() {
      requestAnimationFrame(tick);
      if (!visible) return;
      material.uniforms.uTime.value = clock.getElapsedTime();
      mouseEased.x += (mouse.x - mouseEased.x) * 0.04;
      mouseEased.y += (mouse.y - mouseEased.y) * 0.04;
      material.uniforms.uMouseEased.value.set(mouseEased.x, mouseEased.y);
      renderer.render(scene, camera);
    }
    tick();
  }
}
